
<template>
    
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 姓名｜郵箱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加學生</el-button>
					<el-upload
						action="/admin/data/importExcelUser"  
						:before-upload="beforeUpload"
						:headers="{token:$store.state.user.token}"
						:on-success="handleSuccess"
						:on-error="handleError"
						:show-file-list="false"
						accept=".xlsx,.xls"
					>
						<el-button class="mr-2" type="warning" size="mini">上傳學生Excel文件</el-button>
					</el-upload>
					<el-button @click="downloadTemplate" class="mr-2" type="success" size="mini">下載學生模版文件</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="姓名" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索姓名"></el-input>
						</el-form-item>

						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.uid" placeholder="搜索編號"></el-input>
						</el-form-item>
					
                      
						<el-form-item label="學校" class="mb-0">
							<el-input size="small" v-model="from.school_name" placeholder="搜索學校"></el-input>
						</el-form-item>


                        <el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>


						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>


						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>
        

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>

                <el-table-column type="expand" label="詳情"  width="80">
                    <template slot-scope="props" >
						<el-descriptions style="padding: 0 30px;">
							<el-descriptions-item label="暱稱">{{ props.row.username }}</el-descriptions-item>
							<el-descriptions-item label="生日">{{ props.row.birthday }}</el-descriptions-item>
							<el-descriptions-item label="郵箱">{{ props.row.email }}</el-descriptions-item>
							<el-descriptions-item label="班別">{{ props.row.class_id }}</el-descriptions-item>
							<el-descriptions-item label="學號">{{ props.row.number }}</el-descriptions-item>
							<el-descriptions-item label="聯絡地址">{{ props.row.address }}</el-descriptions-item>
							<el-descriptions-item label="聯絡電話">{{ props.row.phone }}</el-descriptions-item>
							<el-descriptions-item label="已有稱號">{{ props.row.role }}</el-descriptions-item>
							<el-descriptions-item label="創建時間">{{ props.row.create_time }}</el-descriptions-item>
						</el-descriptions>
                        
                    </template>
                </el-table-column>

				<el-table-column align="center"  prop="user_no" label="編號">
				</el-table-column>
				<el-table-column align="center" prop="school_name" label="學校">
				</el-table-column>
				<el-table-column align="center" prop="grade_name" width="50" label="年級">
				</el-table-column>
				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>
				
				<el-table-column align="center" prop="name_en" label="英文姓名">
				</el-table-column>
				
                <el-table-column align="center" prop="head" label="頭像">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="level" label="等級">
				</el-table-column>

				<el-table-column align="center" prop="diamond" label="鑽石數量">
				</el-table-column>

				<el-table-column align="center" prop="coin" label="金幣數量">
				</el-table-column>

				<el-table-column align="center"  prop="type"  label="類型">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.type==1">非學校用戶</span>
						<span class="text-success" v-if="v.row.type==2">學校用戶</span>
					</template>
				</el-table-column>

                <el-table-column align="center" prop="status" label="登錄狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeUserStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="login_time" width="200" label="最後登錄時間">
				</el-table-column>
				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="240" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="openModel(scope.row)"  v-auth="'edit'+auth_val"  size="mini" plain type="primary">操作</el-button>
							<el-button @click="giving(scope.row)"  v-auth="'send'+auth_val"  size="mini" plain type="success">贈送禮物</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val"  size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加用戶':'修改用戶'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form  :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
                <el-form-item label="郵箱" prop="email">
					<el-input type="text"  v-model="form.email" 
					placeholder="郵箱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="姓名" prop="name">
					<el-input type="text"  v-model="form.name" 
					placeholder="姓名" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="姓名（英文）" prop="name_en">
					<el-input type="text"  v-model="form.name_en" 
					placeholder="姓名（英文）" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="性別">
					<el-radio-group v-model="form.sex">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="類型">
					<el-radio-group v-model="form.type">
						<el-radio :label="1">非學校用戶</el-radio>
						<el-radio :label="2">學校用戶</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item label="暱稱" prop="username">
					<el-input type="text"  v-model="form.username" 
					placeholder="暱稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                
                <el-form-item label="年級"  prop="grade_id">
					<el-select v-model="form.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="學校" filterable prop="school_id">
					<el-input v-if="editIndex>0" type="text" disabled v-model="form.str_school" 
					clearable size="small" style="width: 85%;"></el-input>
					<el-select
						v-else
						size="small" style="width: 85%;"
						v-model="form.school_id"
						filterable
						remote
						reserve-keyword
						placeholder="請輸入關鍵詞:學校編號 - 學校地區 - 學校名稱"
						:remote-method="remoteMethodSchool"
						:loading="loading">
						<el-option
						v-for="item in schoolOptions"
						:key="item.id"
						:label="item.str_name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>



                <el-form-item label="班別" prop="class_id">
					<el-input type="text"  v-model="form.class_id" 
					placeholder="班別" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item label="學號" prop="number">
					<el-input type="text"  v-model="form.number" 
					placeholder="學號" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
                <el-form-item label="密碼" prop="password">
					<el-input type="text"  v-model="form.password" 
					placeholder="密碼" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>


                <el-form-item label="鑽石" v-if="editIndex>0">
					<el-button-group>
							<el-button @click="update_money(form,1,1)" size="mini" plain type="success">添加</el-button>
							<el-button @click="update_money(form,1,2)" size="mini" plain type="danger">扣除</el-button>
						</el-button-group>
				</el-form-item>
				
                <el-form-item label="金幣" v-if="editIndex>0">
					<el-button-group>
							<el-button @click="update_money(form,2,1)" size="mini" plain type="success">添加</el-button>
							<el-button @click="update_money(form,2,2)" size="mini" plain type="danger">扣除</el-button>
						</el-button-group>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"   :title="createUpdateTitle" :visible.sync="createUpdateModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<!-- 表單内容 -->
				<el-form :label-width="layout.is_phone?'80px':'100px'">
					<el-form-item label="用戶">
						{{formUpdateUser.name}}
					</el-form-item>
					<el-form-item label="鑽石">
						{{formUpdateUser.diamond}}
					</el-form-item>

					<el-form-item label="金幣">
						{{formUpdateUser.coin}}
					</el-form-item>


					<el-form-item label="數量" >
						<el-input type="number" v-model="formUpdateNum" 
						placeholder="數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
				</el-form>
				
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetUpdateModel">取 消</el-button>
					<el-button type="primary" @click="submitUpdateMoney">確 定</el-button>
				</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"   title="贈送禮物" :visible.sync="createRankingModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
				<!-- 表單内容 -->
				<el-form ref="formRanking" :model="formRanking" :label-width="layout.is_phone?'80px':'100px'">
					
					<el-form-item label="鑽石" prop="diamond">
						<el-input type="number" v-model="formRanking.diamond" 
						placeholder="鑽石數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>
					
					<el-form-item label="金幣" prop="money">
						<el-input type="number" v-model="formRanking.money" 
						placeholder="金幣數量" 
						clearable size="small" style="width: 85%;">
						</el-input>
					</el-form-item>

					<el-form-item label="贈送禮物" prop="gift_id">
										<el-select v-model="formRanking.gift_id" style="width: 85%;" multiple filterable placeholder="請選擇">
											<el-option
											v-for="item in user_gift"
											:key="item.id"
											:label="item.type_name"
											:disabled="item.disabled"
											:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="resetRankingForm">取 消</el-button>
					<el-button type="primary" @click="submitRanking">確 定</el-button>
				</div>
			</el-dialog>

		<!-- 用戶禁用彈窗 -->
		<el-dialog
			title="禁用用戶"
			:visible.sync="statusDialog.visible"
			width="500px"
			:close-on-click-modal="false"
			@close="closeStatusDialog"
		>
			<el-form :model="statusForm" :rules="statusRules" ref="statusForm" label-width="100px">
				<el-form-item label="用戶資訊">
					<div class="user-info">
						<p><strong>用戶ID:</strong> {{ statusForm.user_id }}</p>
						<p><strong>用戶名:</strong> {{ statusForm.name }}</p>
						<p><strong>當前狀態:</strong> 
							<el-tag :type="statusForm.current_status ? 'success' : 'danger'">
								{{ statusForm.current_status ? '啟用' : '禁用' }}
							</el-tag>
						</p>
					</div>
				</el-form-item>
				
				<el-form-item 
					label="禁用原因" 
					prop="reason" 
					:rules="[{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }]"
				>
					<el-input
						v-model="statusForm.reason"
						type="textarea"
						:rows="4"
						placeholder="請輸入禁用用戶的原因..."
						maxlength="500"
						show-word-limit
					></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeStatusDialog">取消</el-button>
				<el-button type="primary" @click="confirmStatusChange" :loading="statusDialog.loading">
					禁用
				</el-button>
			</div>
		</el-dialog>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		
		

	</div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  
  .user-info {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
  }

  .user-info p {
    margin: 5px 0;
    color: #606266;
  }

  .dialog-footer {
    text-align: right;
  }
</style>
<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				formUpdateNum: 0,
				createUpdateModel: false,
				createUpdateTitle: '',
				formUpdateUser: '',

				createRankingModel: false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					email: '',
					school_name: '',
					uid: '',
					school_id: -1,
					grade_id: -1,
					type: -1,
					status: -1,
					time: [],
				},
				model_title: 'User',
				auth_val: 'User',
				preUrl: "data/UserList", //列表地址
				addUrl: "data/editUser", //修改密碼
				delAllUrl: "data/delUserAll", //批量删除地址
				delUrl: "data/delUser", //删除單条地址
                editStatusUrl: "data/editStatusUser", //修改狀態地址

				tableData: [],
				schoolOptions: [],
				form: {
					id: 0,
						name:'',
						sex:1,
						name_en:'',
						username:'',
						grade_id:'',
						class_id:'',
						number:'',
						email:'',
						phone:'',
                        password: '',
                      
				},

				rules: {
					name: [{
							required: true,
							message: "姓名不能為空",
							trigger: 'blur',
						},
					],
					
					username: [{
							required: true,
							message: "暱稱不能為空",
							trigger: 'blur',
						},
					],
					email: [{
							required: true,
							message: "郵箱不能為空",
							trigger: 'blur',
						},
					],
					class_id: [{
							required: true,
							message: "班別不能為空",
							trigger: 'blur',
						},
					],
					number: [{
							required: true,
							message: "學號不能為空",
							trigger: 'blur',
						},
					],
					grade_id: [{
							required: true,
							message: "請選擇年級",
							trigger: 'blur',
						},
					],
					school_id: [{
							required: true,
							message: "請選擇學校",
							trigger: 'blur',
						},
					],
				},
                type:2,
				prop: 'level',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				user_gift: [],
				grade_list: [],
				school_list: [],
				loading:false,
				formRanking:{
					diamond:0,
					money:0,
					gift_id:'',
					name:'',
					uid: 0,
				},
				
				// 用戶狀態修改彈窗
				statusDialog: {
					visible: false,
					loading: false
				},
				statusForm: {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				},
				statusRules: {
					reason: [
						{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }
					]
				},
			}
		},
		created() {
			this.commonList(['user_gift','all_grade_list']);
			this.getList();    // 如果有其他需要刷新的方法
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			update_money(row,type,update){
				const title = update == 2 ? '扣除' : '增加';
				const typeTitle = type == 2 ? '金幣' : '鑽石';
				this.createUpdateTitle = title + ' - ' + typeTitle;
				this.createUpdateModel = true;
				this.formUpdateUser = row;
				this.formUpdateUser.update = update;
				this.formUpdateUser.money_type = type;
			},
			resetUpdateModel(){
				this.createUpdateTitle = '';
				this.formUpdateNum = 0;
				this.formUpdateUser = {};
				this.createUpdateModel = false;
			},
			// 上傳前的文件類型检查
			beforeUpload(file) {
				const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
				if (!isExcel) {
					this.$message.error('只能上傳Excel文件');
				}
				this.layout.loading = true;  // 控制加載层的顯示
				return isExcel;
			},
			// 上傳成功回调
			handleSuccess(res, file, fileList) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res = JSON.parse(en_data)
				this.layout.loading = false;  // 控制加載层的顯示
				if(res.code==0){
					this.$message.error(res.msg);
				}else{
					this.$message.success('文件上傳成功');
					this.getList()
				}
			},
			// 上傳失敗回调
			handleError(error, file, fileList) {
				this.layout.loading = false;  // 控制加載层的顯示
				this.$message.error('文件上傳失敗');
			},
			submitUpdateMoney() {
				this.$confirm(
				`當前操作是${this.createUpdateTitle}（用戶：${this.formUpdateUser.name}），請確認是否繼續？`, 
				'警告', 
				{
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning',
				}
				).then(() => {
					// 執行取消訂單的邏輯
					this.callUpdateMoneyAPI();
				}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消操作已被終止',
				});
				});
			},
			callUpdateMoneyAPI(){
				this.formUpdateUser.update_num = this.formUpdateNum;
				this.layout.loading = true;
				this.axios.post('/admin/data/UpdateUserMoney', this.formUpdateUser, {
					token: true,
				}).then(res => {
					if (all.data.code == 1) {
						this.$message({
								type: 'success',
								message: '操作完成!',
							});
					this.resetUpdateModel()
					this.createModel = false
					this.layout.loading = false;
					this.getList()
							}
					
				}).catch(err => {
					// 失敗
					// this.$message.error('操作失敗，請稍後重試');
					this.layout.loading = false;
				})
			},
			//贈送禮物
			giving(e){
				this.formRanking.uid = e.id
				this.formRanking.name = e.name
				this.createRankingModel = true
			},
			handleClick(tab, event) {
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			downloadTemplate() {
				// 文件的 URL (可以是相對路徑或完整URL)
				// const baseUrl = 'https://api.freetraderex.com';
				const baseUrl = 'https://api.lets-go.fun';
				const filePath = '/excel/學生後台模版文件.xlsx';
				const fileUrl = `${baseUrl}${filePath}`;
				const link = document.createElement('a');
				link.href = fileUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link); // 移除鏈接節點
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			submitRanking() {
				this.layout.loading = true;
				this.axios.post('/admin/data/giftGiving', this.formRanking, {
					token: true,
				}).then(res => {
					this.resetRankingForm()
					this.layout.loading = false;
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			  remoteMethodSchool(query){
				if (query !== '') {
					this.loading = true;
					this.axios.post('/admin/data/getSchoolList', {
						value: query,
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						this.schoolOptions = all.data;
						this.loading = false;
					}).catch(err => {
						// 失敗
						this.schoolOptions = [];
						this.loading = false;
					})
				} else {
					this.schoolOptions = [];
					this.loading = false;
				}
			},
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			  },
			  commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.user_gift = list.user_gift
					this.grade_list = list.all_grade
					
					if (this.subject_list.length > 0) {
						
						// 设置默認选中项为subject_list中的第一个元素
						this.form.subject_id = this.subject_list[0].id
						this.label_list = list.label[this.subject_list[0].id]
						if (this.label_list.length > 0) {
							// 设置默認选中项为subject_list中的第一个元素
							this.label_ids = this.label_list[0].id;
						}
					}
					this.layout.loading = false;
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			resetRankingForm() {
				this.formRanking = {
					diamond:0,
					money:0,
					name:'',
					gift_id:'',
					uid: 0,
				};
				
				this.createRankingModel = false;
			},
			
			// 用戶狀態修改
			changeUserStatus(row) {
				const newStatus = row.status === 1 ? 0 : 1;
				
				// 如果是啟用操作，直接調用API
				if (newStatus === 1) {
					this.directEnableUser(row);
					return;
				}
				
				// 如果是禁用操作，顯示彈窗
				this.statusForm = {
					user_id: row.id,
					name: row.name,
					current_status: row.status,
					reason: ''
				};
				this.statusDialog = {
					visible: true,
					loading: false
				};
				
				// 清空表單驗證
				this.$nextTick(() => {
					if (this.$refs.statusForm) {
						this.$refs.statusForm.clearValidate();
					}
				});
			},
			
			// 直接啟用用戶
			directEnableUser(row) {
				this.$confirm('確認啟用該用戶嗎？', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					this.axios.post('/admin/data/editStatusUser', {
						id: row.id,
						status: 1,
						reason: ''
					}, {
						token: true
					}).then(res => {
						if (res.data.code === 1) {
							// 更新本地數據
							row.status = 1;
							this.$message({
								message: '啟用成功',
								type: 'success'
							});
							// 刷新列表
							this.getList();
						} else {
							this.$message.error(res.data.msg || '操作失敗');
						}
					}).catch(err => {
						this.$message.error('操作失敗，請稍後重試');
					});
				}).catch(() => {
					// 用戶取消操作
				});
			},
			
			// 關閉狀態彈窗
			closeStatusDialog() {
				this.statusDialog.visible = false;
				this.statusForm = {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				};
			},
			
			// 確認狀態修改
			confirmStatusChange() {
				this.$refs.statusForm.validate((valid) => {
					if (valid) {
						this.statusDialog.loading = true;
						
						// 調用API修改狀態
						this.axios.post('/admin/data/editStatusUser', {
							id: this.statusForm.user_id,
							status: 0,
							reason: this.statusForm.reason
						}, {
							token: true
						}).then(res => {
							if (res.data.code === 1) {
								// 更新本地數據
								const user = this.tableData.find(item => item.id === this.statusForm.user_id);
								if (user) {
									user.status = 0;
								}
								
								this.$message({
									message: '禁用成功',
									type: 'success'
								});
								
								// 刷新列表
								this.getList();
							} else {
								this.$message.error(res.data.msg || '操作失敗');
							}
							this.closeStatusDialog();
						}).catch(err => {
							this.$message.error('操作失敗，請稍後重試');
							this.closeStatusDialog();
						}).finally(() => {
							this.statusDialog.loading = false;
						});
					}
				});
			},

			// 打开模态框
			openModel(e, type) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						name_en: e.name_en,
						username:e.username,
						grade_id:e.grade_id,
						school_id:e.school_id,
						diamond:e.diamond,
						coin:e.coin,
						class_id:e.class_id,
						sex:e.sex,
						number:e.number,
						email:e.email,
						str_school:e.str_school,
						type:e.type,
						
                        password: '',
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:'',
						name_en:'',
						username:'',
						grade_id:'',
						sex:1,
						type:1,
						class_id:'',
						number:'',
						email:'',
						password: '',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					email: '',
					school_name: '',
					uid: '',
					school_id: -1,
					grade_id: -1,
					type: -1,
					status: -1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
